<template>
  <div id="app">
    <Home />
  </div>
</template>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #dddddd;
  margin: 0px;
  width: 100%;
  height: 100%;
}
b {
    color: #cc0000;
}
</style>

<script>
import Home from './pages/Home'

export default {
    comments: true,
    name: 'app',
    components: {
        Home
    },
    data() {
        return {
        }
    }
}
</script>
